<script lang="ts">
  import type { BackendActor } from '../actor';
  import { assets, playSound } from '../assets';
  import { logout, type AuthenticatedState } from '../auth';
  import { guide } from '../guide';
  import OutsideLayout from './OutsideLayout.svelte';

  export let actor: BackendActor;
  export let auth: AuthenticatedState;
  let name: string;
  let joining: boolean;
  let startingTutorial: boolean;

  async function joinLobby() {
    joining = true;
    try {
      await actor.join_lobby(name);

      playSound(assets.sounds.click);
    } catch {
    } finally {
      joining = false;
    }
  }

  async function playTutorial() {
    $guide.clear();
    startingTutorial = true;
    try {
      await actor.start_tutorial_game();
    } catch {
    } finally {
      startingTutorial = false;
    }
  }
</script>

<OutsideLayout>
  <form
    class="flex flex-col gap-8 max-w-xs mx-auto"
    on:submit|preventDefault={() => joinLobby()}
  >
    <input
      type="text"
      bind:value={name}
      class="input input-bordered w-full"
      placeholder="Your in-game name..."
      autofocus
      required
    />
    <div class="flex">
      <button
        class="btn btn-primary {joining && 'loading'} flex-1"
        disabled={joining}>Join lobby</button
      >

      <button on:click={() => logout()} class="btn btn-ghost" type="button"
        >Logout</button
      >
    </div>
  </form>

  <div class="mt-10">
    <p class="mb-4">Or play the tutorial</p>
    <button
      type="button"
      on:click={() => playTutorial()}
      class="btn btn-outline {startingTutorial && 'loading'} flex-1"
      disabled={startingTutorial}>Play the tutorial</button
    >
  </div>

  <div class="text-gray-500 text-xs mt-10">
    You're logged in as <span class="text-gray-400"
      >{auth.client.getIdentity().getPrincipal().toString()}</span
    >
  </div>
</OutsideLayout>
